import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LeftRightExpandedIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';
import { PAGE_CODES } from 'constants/pageCodes';
import { useDocumentPaneCapacity } from 'hooks/useDocumentPaneCapacity';
import { useWideWorkspace } from 'hooks/useWideWorkspace';

import { getMasterPermissionsToPage } from 'store/auth/selectors';
import { openDocumentPaneAction } from 'store/loanApplications/actions';

import ActionButton from '../ActionButton';

/**
 * Header button (available on every loan-editor tab) that opens the Documents browser in a side
 * pane. Shown only on a wide workspace with documents-view permission; disabled when the window
 * has no room for another pane or the 2-pane cap is reached.
 */
const OpenDocumentsPaneButton = () => {
  const dispatch = useDispatch();

  const { isViewAllowed } = useSelector(getMasterPermissionsToPage(PAGE_CODES.DOCUMENTS));
  const { isWideWorkspace } = useWideWorkspace();
  const { canAddPane } = useDocumentPaneCapacity();

  const onOpen = useCallback(() => dispatch(openDocumentPaneAction()), [dispatch]);

  if (!isViewAllowed || !isWideWorkspace) {
    return null;
  }

  return (
    <ActionButton disabled={!canAddPane} onClick={onOpen}>
      <LeftRightExpandedIcon size={IconSize[16]} />
    </ActionButton>
  );
};

export default OpenDocumentsPaneButton;
